export const COLORFUL_OPTION_HEX = 'multicolor';
